export default __webpack_public_path__ + "static/media/icon-gift.9f608bb4.svg";